import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-award mr1" }),
  /*#__PURE__*/_createTextVNode(" Stats ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"14px","text-transform":"initial"},
  class: "mt2"
}, " Based on your best match. ", -1)
const _hoisted_3 = {
  key: 0,
  class: "flex-centered col-12",
  style: {"height":"100%"}
}
const _hoisted_4 = {
  key: 1,
  class: "container-centered p2"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "k-score-error-message" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "k-error-text" }, "¯\\_(ツ)_/¯"),
  /*#__PURE__*/_createElementVNode("p", { class: "k-error-text mb0" }, "Hm, I had some trouble fetching your stats. Try again later maybe.")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Back to Menu ")

import * as GameTypes from 'types/game.types';
    import { reactive, computed, ref } from 'vue';
    import NavigableScreen from 'components/navigable-screen.vue';
    import NavButton from 'components/nav-button.vue';
    import AchievementMenu from './achievement-menu.vue';
    import Spinner from 'components/spinner.vue';
    import { useModule } from 'src/modules/modules';
    import MatchSummary from 'src/game/match-summary.vue';
    import { delay } from 'src/util/util';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'score-menu',
  emits: ['back'],
  setup(__props, { emit }) {

_useCssVars(_ctx => ({
  "754ffafe": (_unref(theme).theme.titleBg)
}))

    const { stats, theme } = useModule();
    
    const handleNativeBack = () => emit('back');
    const state = reactive<{
        loading: boolean
    }>({
        loading: true
    });

    const statsRes = ref<GameTypes.RankedPersistedStats | false>(false);
    const postGameAsyncTimeout = 12000;
    const getBestStats = async () => {
        state.loading = true;
        try {
            statsRes.value = await Promise.race<ReturnType<typeof stats.getBest> | false>([
                stats.getBest(), 
                delay<false>(postGameAsyncTimeout, false)
            ]);

                console.log("DONE!");

        } catch (errors){
            console.warn(errors);
            statsRes.value = false;
        }
        state.loading = false;
    }

    getBestStats();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(NavigableScreen, {
      "use-banner-offset": "",
      onNativeBack: handleNativeBack
    }, {
      title: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      content: _withCtx(() => [
        (state.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(Spinner)
            ]))
          : (statsRes.value === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            : (_openBlock(), _createBlock(MatchSummary, {
                key: 2,
                context: "best",
                stats: statsRes.value
              }, null, 8, ["stats"]))
      ]),
      "nav-center": _withCtx(() => [
        _createVNode(NavButton, {
          type: "back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back')))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})